import { Button, Checkbox, Image, Result, Upload, message } from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from "./OurPartners.module.css";
import { ReactComponent as SecondTruck } from "../../../assets/secondTruckSvg.svg";
import { ReactComponent as FirstTruck } from "../../../assets/firstTruckSvg.svg";

import MisionImage from "../../../assets/postmanPartners.png";
import { usernamePasswordValidate } from "../../../types/UsernamePasswordValidate";

import {
	fetchZonesCached,
	getConfigurationValueCached,
} from "../../../lib/cachedLookups";
import {
	useConfiguration,
	useConfigurationNumber,
} from "../../../hooks/useConfiguration";
import { ConfigurationId } from "../../../types/Lookups";
import api from "../../../utils/axios";
import { toast } from "react-toastify";
import { userRoles } from "../../../types/enums";
import DefaultInput from "../../../components/form/DefaultInput";
import DefaultPasswordInput from "../../../components/form/DefaultPasswordInput";
import DefaultSelect from "../../../components/form/DefaultSelect";
import {
	CheckCircleTwoTone,
	CloseCircleTwoTone,
	UploadOutlined,
} from "@ant-design/icons";
import useLang from "../../../hooks/useLang";
import DefaultPhoneInput from "../../../components/form/DefaultPhoneInput";
import DefaultSwitch from "../../../components/form/DefaultSwitch";
import PlaceAutocomplete from "../../../components/GoogleMaps/PlaceAutocomplete";
import { CONFIG } from "../../../config";

const pdfReadMore = "/Kontrata.pdf";

const OurPartners = () => {
	const [submitted, setSubmitted] = useState<boolean>(false);
	const [firstLastName, setFirstLastName] = useState<string>("");
	const [email, setEmail] = useState<string>("");
	const [username, setUsername] = useState<string>("");
	const [password, setPassword] = useState<string>("");
	const [confirmPassword, setConfirmPassword] = useState<string>("");
	const [phone, setPhone] = useState<string>("");
	const [address, setAddress] = useState<string>("");
	const [identificationNumber, setIdentificationNumber] = useState<
		string | undefined
	>();
	const [country, setCountry] = useState<string | undefined>();
	const [city, setCity] = useState<string | undefined>();
	const [businessNumber, setBusinessNumber] = useState<string>("");
	const [businessName, setBusinessName] = useState<string>("");
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [sectionId, setSectionId] = useState<number>();
	const [finalAddress, setFinalAddress] = useState<string>("");
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	const [position, setPosition] = useState<any>(null);
	const [adressPosition, setAddressPosition] = useState<any>(null);
	const [error, setError] = useState<boolean>(false);
	const [countryError, setCountryError] = useState<boolean>(false);
	const [cityError, setCityError] = useState<boolean>(false);
	const [addressError, setAddressError] = useState<boolean>(false);

	const [vat, setVat] = useState<boolean>(false);
	const [cash, setCash] = useState<boolean>(true);
	const [bank, setBank] = useState<boolean>(false);
	const [openPhoneCodeConfirmationModal, setOpenPhoneCodeConfirmationModal] =
		useState<boolean>(false);
	const [phoneCode, setPhoneCode] = useState<string>("");
	const phonePrefix = useConfiguration(ConfigurationId.PhonePrefix) ?? "";
	const personalIdLength = useConfigurationNumber(
		ConfigurationId.PersonalIdLength
	);
	const [checkbox, setCheckbox] = useState<boolean>(false);

	const setCountriesAndCities = async () => {
		const [zones, countryId] = await Promise.all([
			fetchZonesCached(),
			getConfigurationValueCached(ConfigurationId.Country),
		]);
		if (zones) {
			const countries = zones
				.filter(
					(item: any) => item.levelId === 1 && item.id == countryId
				)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCountryDropDown(countries);
			const filteredCities = zones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = zones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
		}
	};

	useEffect(() => {
		setCountriesAndCities();
		if (submitted) {
			const timeoutId = setTimeout(() => {
				setSubmitted(false);
			}, 30 * 1000);
			return () => clearTimeout(timeoutId);
		}
	}, []);

	const onCountrySelect = (e: any) => {
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setAddress("");
		(autocompleteRef as any).current.handleClear();
		setCountry(e);
		if (e === 1) {
			setCountryLabel("xk");
		} else if (e === 2) {
			setCountryLabel("al");
		} else if (e === 3) {
			setCountryLabel("mk");
		}
		setCity("");
	};

	const onCitySelect = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setCity(id);
			setCityLabel(value?.label);
			setAddress("");
			(autocompleteRef as any).current.handleClear();
		} else {
			setCity("");
			setCityLabel("");
			setAddress("");
			(autocompleteRef as any).current.handleClear();
		}
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneMbledhs ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				setSectionId(result.geofence_name as number);
				// setFinalAddress(result.result);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	// const [data, setData] = useState<SelectProps["options"]>([]);
	// const [addressTypingTimeout, setAddressTypingTimeout] = useState<any>(null);

	// useEffect(() => {
	// 	return () => {
	// 		if (addressTypingTimeout) {
	// 			clearTimeout(addressTypingTimeout);
	// 		}
	// 	};
	// }, [addressTypingTimeout]);

	let autocompleteRef = useRef<any>();

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setAddressPosition([lat, lng]);
			setPosition([lat, lng]);
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
			setAddress(address);
		}
	};

	const isFormValid = () => {
		if (
			!firstLastName ||
			!email ||
			!username ||
			!password ||
			!confirmPassword ||
			!phone ||
			!country ||
			!city ||
			!address ||
			!identificationNumber
		) {
			if (!country) setCountryError(true);
			if (!city) setCityError(true);
			if (!address) setAddressError(true);
			setError(true);
			return false;
		}
		return true;
	};

	const handleSubmit = async (e: any) => {
		e.preventDefault();
		if (!checkbox) {
			toast.error("Please accept the terms of use");
			return;
		}

		if (!isFormValid()) {
			return;
		}

		setError(false);

		const validatePhoneNumber = (phone: string) => {
			const phoneRegex = /^\d{9}$/;
			return phoneRegex.test(phone);
		};

		if (!validatePhoneNumber(phone)) {
			toast.error(
				"Invalid phone number. Phone number must have 9 digits"
			);
			return;
		}

		if (password !== confirmPassword) {
			toast.error("Passwords do not match");
			return;
		}

		if (identificationNumber?.length !== personalIdLength) {
			toast.error("Invalid Identification number");
			return;
		}

		const result = {
			fullName: firstLastName,
			email: email,
			username: username,
			password: password,
			confirmPassword: confirmPassword,
			phone: phonePrefix + phone,
			country: country,
			city: city,
			address: address,
			latitude: apiLatitude,
			longitude: apiLongitude,
			identificationNumber: identificationNumber,
			businessNumber: businessNumber,
			businessName: businessName,
			vat: vat,
			cash: cash,
			bank: bank,
		};

		try {
			const response = await api.post("Accounts/register", result);
			if (response.status === 200) {
				setOpenPhoneCodeConfirmationModal(true);
				toast.success(
					"Please confirm your phone number by writing the code you received"
				);
			}
		} catch (err) {
			const error = err as any;
			if (error.response.status === 409) {
				toast.error("Username already exists");
			} else if (error.response.status === 400) {
				toast.error("Validation error");
			} else if (error.response.status === 500) {
				toast.error("Server error");
			} else {
				toast.error("An unknown error occurred");
			}
		}
	};

	const handlePhoneCodeSubmit = async () => {
		const phoneCodeData = {
			username: username,
			code: phoneCode,
		};

		try {
			const response = await api.post(
				"Accounts/verify-phone-code",
				phoneCodeData
			);
			if (response.status === 200) {
				setSubmitted(true);
				setOpenPhoneCodeConfirmationModal(false);
				toast.success("User registered successfully");
				setFirstLastName("");
				setEmail("");
				setUsername("");
				setPassword("");
				setConfirmPassword("");
				setPhone("");
				setAddress("");
				setIdentificationNumber("");
				setCountry("");
				setCity("");
				setBusinessNumber("");
				setBusinessName("");
				setVat(false);
				setCash(true);
				setBank(false);
				setCheckbox(false);
			}
		} catch (err) {
			const error = err as any;
			if (error.response.status === 400) {
				toast.error("Invalid code");
			} else {
				toast.error("An unknown error occurred");
			}
		}
	};

	const validateInsertedData = (data: any) => {
		const {
			firstName,
			lastName,
			phone,
			address,
			username,
			password,
			identificationNumber,
			sectionId,
		} = data;
		if (
			!firstName ||
			!lastName ||
			!phone ||
			!address ||
			!username ||
			!password ||
			!identificationNumber ||
			!sectionId
		) {
			if (!firstName) toast.error("Emri është i detyrueshëm");
			if (!lastName) toast.error("Mbiemri është i detyrueshëm");
			if (!phone) toast.error("Numri i telefonit është i detyrueshëm");
			if (!address) toast.error("Adresa është e detyrueshme");
			if (!username) toast.error("Username është i detyrueshëm");
			if (!password) toast.error("Fjalekalimi është i detyrueshëm");
			console.log(
				!identificationNumber,
				identificationNumber,
				"identificatio12n"
			);

			if (!identificationNumber)
				toast.error("Nr i leternjoftimit është i detyrueshëm.");
			if (identificationNumber?.length !== personalIdLength)
				toast.error(
					`Nr i leternjoftimi duhet te kete ${personalIdLength} karaktere`
				);
			if (!sectionId) toast.error("Error zona");

			return false;
		}
		return true;
	};

	const onApply = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		// const fullAddress = finalAddress.split("/");
		// const splitAddress = fullAddress[0] || "";

		const otpNumber = {
			numbers: [phone],
		};
		const validation = usernamePasswordValidate(username, password);

		if (!validation.valid) {
			toast.error(validation.message);
			return;
		}
		if (!phone.startsWith(phonePrefix) && phone.length !== 11) {
			toast.error(
				`Numri i telefonit duhet te filloje me ${phonePrefix} dhe te kete 11 numra`
			);
			return;
		}
		const data = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: vat,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNr: businessNumber,
			status: false,
			approved: false,
		};
		if (validateInsertedData(data)) {
			const resendOtp = await checkPhoneNumber();
			if (!resendOtp) {
				try {
					const response = await api.post(
						"OTP/insert-otp",
						otpNumber
					);
					if (response.data.success === true) {
						setOpenPhoneCodeConfirmationModal(true);
					}
				} catch (error) {
					console.log(error);
					return;
				}
			} else {
				setOpenPhoneCodeConfirmationModal(true);
			}
		} else {
			return;
		}
	};

	const registerClient = async () => {
		const fullNameArray = firstLastName.split(" ");
		const firstName = fullNameArray[0] || "";
		const lastName = fullNameArray.slice(1).join(" ");

		// const fullAddress = finalAddress.split("/");
		// const splitAddress = fullAddress[0] || "";

		const data = {
			firstName: firstName,
			lastName: lastName,
			phone: phone,
			address: address,
			username: username,
			email: email,
			password: password,
			userRoleId: userRoles.CLIENT,
			identificationNumber: identificationNumber,
			sectionId: sectionId,
			longitude: apiLongitude?.toString(),
			latitude: apiLatitude?.toString(),
			packagePriceIncudesTaxes: vat,
			bankPackageTransportPayment: bank,
			cashPackageTransportPayment: cash,
			businessName: businessName,
			businessNr: businessNumber,
			status: false,
			approved: false,
			code: phoneCode,
		};

		if (!phone.startsWith(phonePrefix) && phone.length !== 11) {
			toast.error(`Numri i telefonit duhet te filloje me ${phonePrefix}`);
			return;
		}

		try {
			const response = await api.post("User/main-register", data);
			if (response?.status === 200) {
				toast.success("Aplikimi u krye me sukses!");
				setSubmitted(true);
				cleanRegisterState();
				return;
			} else {
				toast.error(
					"Një gabim ndodhi gjatë aplikimit tuaj. Ju lutemi provoni përsëri më vonë"
				);
			}
		} catch (error: any) {
			console.log(error?.response?.data);
		}
	};

	const handleBlur = useCallback(() => {
		if (password !== confirmPassword) {
			message.error("Passwords do not match");
			setError(true);
		} else {
			setError(false);
		}
	}, [confirmPassword, password]);

	const handleConfirmPasswordChange = (e: any) => {
		setConfirmPassword(e.target.value);
		if (password === e.target.value) {
			setError(false);
		}
	};

	const checkPhoneNumber = async () => {
		if (!phone) {
			toast.error(
				"Ju lutem shenoni Kodin te cilin e keni pranuar ne telefon"
			);
			return;
		}
		try {
			const response = await api.get("OTP/select-otp", {
				params: { phoneNumber: phone },
			});
			if (response.status === 200) {
				return response?.data;
			}
		} catch (error) {}
	};

	const checkPhoneCode = async () => {
		if (!phoneCode) {
			toast.error(
				"Ju lutem shenoni Kodin te cilin e keni pranuar ne telefon"
			);
			return;
		}
		try {
			const response = await api.get("OTP/select-otp", {
				params: { code: phoneCode, phoneNumber: phone },
			});
			if (response.status === 200 && response.data === true) {
				clearePhoneCodeModalState();
				registerClient();
			}
		} catch (error) {}
	};

	const clearePhoneCodeModalState = () => {
		setOpenPhoneCodeConfirmationModal(false);
		setPhoneCode("");
	};

	const cleanRegisterState = () => {
		setFirstLastName("");
		setPhone("");
		setAddress("");
		(autocompleteRef as any).current.handleClear();
		setFinalAddress("");
		setUsername("");
		setEmail("");
		setPassword("");
		setConfirmPassword("");
		setIdentificationNumber("");
		setSectionId(0);
		// setApiLongitude("");
		// setApiLatitude("");
		setBank(false);
		setCash(true);
		setBusinessName("");
		setBusinessNumber("");
		setCountriesAndCities();
	};

	const phoneNumberChange = (e: any) => {
		const phoneNumber = e.target.value;
		setPhone(phoneNumber);
	};

	// const handleSearch = (address: any) => {
	// 	if (!country || !city) {
	// 		toast.error("Ju lutem zgjedhni shtetin dhe qytetin");
	// 		setAddress("");
	// 		return;
	// 	}
	// 	if (addressTypingTimeout) {
	// 		clearTimeout(addressTypingTimeout);
	// 	}

	// 	setAddressTypingTimeout(
	// 		setTimeout(() => {
	// 			fetchAddresesSearch(
	// 				address +
	// 					" ," +
	// 					(cityLabel && cityLabel?.length > 0 ? cityLabel : "")
	// 			);
	// 		}, 400)
	// 	);
	// };

	// const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org/search?";

	// const fetchAddresesSearch = (address: any) => {
	// 	const params = {
	// 		q: address || "",
	// 		format: "json",
	// 		addressdetails: "1",
	// 		polygon_geojson: "0",
	// 	};
	// 	const queryString = new URLSearchParams(params).toString();
	// 	const requestOptions: RequestInit = {
	// 		method: "GET",
	// 		redirect: "follow",
	// 	};
	// 	fetch(
	// 		`${NOMINATIM_BASE_URL}${queryString},${cityLabel}&countrycodes=${countryLabel}`,
	// 		requestOptions
	// 	)
	// 		.then((response) => response.text())
	// 		.then((result) => {
	// 			setData(JSON.parse(result));
	// 		})
	// 		.catch((err) => console.log("err: ", err));
	// };

	const { strings } = useLang("registerForm");

	const [businessPhoneNumber, setBusinessPhoneNumber] = useState<string>("");
	const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
	const [businessSelectedFiles, setBusinessSelectedFiles] = useState<File[]>(
		[]
	);

	const changeSwitch = () => {
		setCash((prevState) => !prevState);
		setBank((prevState) => !prevState);
	};

	const handleFileChange = (event: any) => {
		if (event.target?.files?.length) {
			const file: any = Array.from(event.target.files);
			setSelectedFiles(file);
		}
	};

	const handleFileChangeBusieness = (event: any) => {
		if (event.target?.files?.length) {
			const file: any = Array.from(event.target.files);
			setBusinessSelectedFiles(file);
		}
	};

	return (
		<>
			<div className={classes.bossContainer}>
				<div className={classes.mainContainer}>
					<div className={classes.textContainer}>
						<h1 className={classes.h1Text}>Partnerët Tanë</h1>
						<p className={classes.pText}>
							Postman si lider i shërbimeve postare në Kosovë do
							të vazhdojë edhe <br /> me tutje të ofrojë shërbime
							profesionale për të gjithë bashkëpunëtorët <br />{" "}
							tanë duke sjell risi dhe inovacion në vazhdimësi.  
						</p>
					</div>
				</div>
				<div className={classes.secondComponent}>
					<div className={classes.secondFirstItem}>
						<p className={classes.secondFirstItemText}>
							Për POSTMAN?
						</p>
						<p className={classes.secondFirstItemDesc}>
							Në Postman, kemi kënaqësinë të bashkëpunojmë me mbi
							7000 biznese dhe klientë të ndryshëm me të cilët
							ndajmë vizionin e përbashkët për shërbime të
							besueshme, të shpejta dhe profesionale.
						</p>
					</div>
					<div className={classes.secondItems}>
						<p className="text-center">
							Postman është përkushtuar që të qëndrojë pas 4
							komponentëve kryesore postare:
						</p>
						<div className={classes.fourComponents}>
							<p className={classes.fourItem}>
								&#x2713; Besueshmëria
							</p>
							<p className={classes.fourItem}>
								&#x2713; Shtrirja
							</p>
							<p className={classes.fourItem}>
								&#x2713; Rëndësia
							</p>
							<p className={classes.fourItem}>
								&#x2713; Qëndrueshmëria
							</p>
						</div>
					</div>
					<Image src={MisionImage} preview={false} />
				</div>
				<div className={classes.secondComponent}>
					<div className={classes.secondFirstItem}>
						<p className={classes.secondFirstItemText}>
							Bashkohuni me NE
						</p>
						<p className={classes.secondFirstItemDesc}>
							Nëse jeni një kompani, organizatë apo individ që
							kërkon një partner për shërbime të shpejta dhe të
							besueshme të dorëzimit, ju lutemi na kontaktoni për
							të mësuar më shumë rreth mundësive të bashkëpunimit.
						</p>
						<p>
							Ne jemi të hapur për të eksploruar mënyra të reja
							për të rritur rrjetin tonë të partnerëve dhe për të
							ofruar vlerë shtesë për klientët tanë të përbashkët.
						</p>
					</div>
				</div>
				<div className={classes.registerFormMainContainer}>
					<FirstTruck className={classes.firstTruck} />

					<div className={classes.registerFormContainer}>
						<p className={classes.secondFirstItemText}>
							Bashkëpuno me ne
						</p>
						<p className="font-inter font-semibold text-xl leading-6 text-gray-700">
							Apliko për të hapur llogari me ne:
						</p>
						{submitted && (
							<>
								<div className="flex justify-center items-center p-10">
									<div className="bg-white w-2/4">
										<Result
											status="success"
											title="Successfully Registered"
											subTitle="Thank you for trusting Postman! Your account will be approved in less than 24 Hours"
											className="bg-white"
										/>
									</div>
								</div>
							</>
						)}
						<div className={classes.registerForm}>
							<div className={classes.registerFormInputs}>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.firstLastName.label}
									placeholder={
										strings?.inputs.firstLastName
											.placeholder
									}
									value={firstLastName}
									onChange={(e) =>
										setFirstLastName(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.phone.label}
									placeholder={
										strings?.inputs.phone.placeholder
									}
									value={phone}
									onChange={(e) => phoneNumberChange(e)}
								/>
								<DefaultInput
									className="registerInput"
									label={
										strings?.inputs.identificationNumber
											.label
									}
									value={identificationNumber}
									onChange={(e) =>
										setIdentificationNumber(e.target.value)
									}
									placeholder={
										strings?.inputs.identificationNumber
											.placeholder
									}
								/>

								<DefaultInput
									className="registerInput"
									label={strings?.inputs.username.label}
									placeholder={
										strings?.inputs.username.placeholder
									}
									value={username}
									onChange={(e) =>
										setUsername(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.email.label}
									placeholder={
										strings?.inputs.email.placeholder
									}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<DefaultPasswordInput
									className="registerInput"
									label={strings?.inputs.password.label}
									value={password}
									placeholder={
										strings?.inputs.password.placeholder
									}
									onChange={(e) =>
										setPassword(e.target.value)
									}
									onBlur={handleBlur}
									allowClear={true}
								/>
								<DefaultInput
									label={
										strings?.inputs.confirmPassword.label
									}
									className="registerInput"
									value={confirmPassword}
									onChange={handleConfirmPasswordChange}
									onBlur={handleBlur}
									placeholder={
										strings?.inputs.confirmPassword
											.placeholder
									}
									status={error ? "error" : ""}
									type="password"
									suffix={
										error ? (
											<CloseCircleTwoTone twoToneColor="#ff4d4f" />
										) : (
											<CheckCircleTwoTone twoToneColor="#52c41a" />
										)
									}
									allowClear={true}
								/>
								<DefaultSelect
									className="registerInput"
									onChange={onCountrySelect}
									value={country}
									placeholder={
										strings?.inputs.country.placeholder
									}
									label={strings?.inputs.country.label}
									flexDirection="col"
									alignCenter="start"
									options={countryDropDown}
									allowClear
									status={countryError ? "error" : ""}
								/>
								<DefaultSelect
									className="registerInput"
									placeholder={
										strings?.inputs.city.placeholder
									}
									value={city}
									onChange={onCitySelect}
									label={strings?.inputs.city.label}
									flexDirection="col"
									alignCenter="start"
									options={cityDropDown}
									allowClear
									labelInValue={true}
									status={cityError ? "error" : ""}
								/>
								<div className="flex flex-col items-start ">
									<label className="w-42 -mt-1">
										{strings?.inputs.address.label}
									</label>
									{/* <Select
										className="registerInput"
										showSearch
										value={address}
										placeholder={
											strings?.inputs.address.placeholder
										}
										defaultActiveFirstOption={false}
										suffixIcon={null}
										filterOption={false}
										onSearch={handleSearch}
										onChange={handleChange}
										notFoundContent={null}
										options={(data as any)?.map(
											(d: any) => ({
												value: d.osm_id,
												label: d.display_name,
											})
										)}
										status={addressError ? "error" : ""}
									/> */}
									<PlaceAutocomplete
										onAddressChange={handleChange}
										country={countryLabel}
										ref={autocompleteRef}
									/>
									{/* <AddressSelect
										onAddressChange={handleChange}
										country={countryLabel}
										selectedAddress={address}
										city={cityLabel}
									/> */}
								</div>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.businessName.label}
									placeholder={
										strings?.inputs.businessName.placeholder
									}
									value={businessName}
									onChange={(e) =>
										setBusinessName(e.target.value)
									}
								/>
								<DefaultInput
									className="registerInput"
									label={strings?.inputs.businessNumber.label}
									placeholder={
										strings?.inputs.businessNumber
											.placeholder
									}
									value={businessNumber}
									onChange={(e) =>
										setBusinessNumber(e.target.value)
									}
								/>
								<DefaultPhoneInput
									className="registerInputPhone"
									label={strings?.inputs.businessPhone.label}
									placeholder={
										strings?.inputs.businessPhone
											.placeholder
									}
									initialPhoneNumber={businessPhoneNumber}
									onPhoneNumberChange={(v) =>
										setBusinessPhoneNumber(v)
									}
								/>
								<div className="flex flex-col items-start justify-start w-auto gap-2  gap-4">
									<p>
										{strings?.switches.postalServicePayment}
									</p>
									<div className="flex flex-row justify-around gap-2">
										<DefaultSwitch
											label={strings?.switches.cash}
											checked={cash}
											onChange={changeSwitch}
										/>
										<DefaultSwitch
											label={strings?.switches.bank}
											checked={bank}
											onChange={changeSwitch}
										/>
									</div>
								</div>

								<div className="uploadFilesDiv">
									<div className="flex flex-col">
										<label
											htmlFor="fileInput"
											className="block mb-2"
										>
											{
												strings?.inputs.fileUpload
													.firstInsert
											}
										</label>
										<Upload
											onChange={handleFileChange}
											multiple={true}
											beforeUpload={() => false}
											accept="image/*"
										>
											<Button
												icon={<UploadOutlined />}
												className="buttonUploadFile"
											>
												{
													strings?.inputs.fileUpload
														.choose
												}
											</Button>
										</Upload>
									</div>
									<div className="flex flex-col">
										<label
											htmlFor="fileInput"
											className="block mb-2"
										>
											{
												strings?.inputs.fileUpload
													.secondInsert
											}
										</label>
										<Upload
											onChange={handleFileChangeBusieness}
											multiple={true}
											beforeUpload={() => false}
										>
											<Button
												icon={<UploadOutlined />}
												className="buttonUploadFile"
											>
												{
													strings?.inputs.fileUpload
														.choose
												}
											</Button>
										</Upload>
									</div>
								</div>
							</div>
							<div className="flex flex-wrap  gap-8 mt-4">
								<div className="flex flex-row justify-center items-center gap-4">
									<Checkbox
										onChange={(e) =>
											setCheckbox(e.target.checked)
										}
										value={checkbox}
									/>
									<p className="text-wrap">
										{strings?.checkboxText}
										<a
											href={pdfReadMore}
											target="_blank"
											rel="noreferrer"
											className="text-sky-600"
										>
											{strings?.readMore}
										</a>
									</p>
								</div>
							</div>
							<div className="lastDiv">
								<Button
									className="registerButton"
									onClick={onApply}
									disabled={!checkbox}
								>
									{strings?.applyButton}
								</Button>
							</div>
						</div>
					</div>
					<SecondTruck className={classes.secondTruck} />
				</div>
				{/* <NewsDiv /> */}
			</div>
		</>
	);
};

export default OurPartners;
